var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-over",class:{ active: _vm.active }},[_c('div',{staticClass:"backdrop"},[_c('h1',[_vm._v(_vm._s(_vm.text))]),_c('button',{on:{"click":_vm.close}},[_vm._v("Close")])])])}
var staticRenderFns = []

export { render, staticRenderFns }